export function elapsedSince(dateString?: string | null): string {
  if (!dateString) return '-'

  const diff = Date.now() - new Date(dateString).getTime()
  if (Number.isNaN(diff) || diff < 0) return '-'

  const minutes = Math.floor(diff / 60000)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (days >= 1) return `${days} روز`
  if (hours >= 1) return `${hours} ساعت`
  if (minutes >= 1) return `${minutes} دقیقه`
  return 'چند لحظه'
}
